import request from '../../utils/request';
import { getURL } from '../../utils/apiURLBuilder';



export function doQRCODE(data) {
  const body = {
    service: 'LoginQRGet',
    params: {
      ...data
    }
  }

  return request.post(getURL(), body);
}



export function checkQRCode(qrCode) { 
  const body = {
    service: 'LoginQREvent',
    params: {
      codigoQR:qrCode
    }
  }

  return request.post(getURL(), body);
}

export function doLogin(data) {
  const body = {
    service: 'LogInWebRequest',
    params: {
      ...data
    }
  }

  return request.post(getURL(), body);
}

export function checkLogin(data) {
  const body = {
    service: 'LogInWebCheck',
    params: {
      ...data
    }
  }

  return request.post(getURL(), body);
}

export function doLogout(data) {
  return request.post(getURL(`/revoke`), data);
}

export function getRoles(data) {
  const body = {
    service: 'UsuarioWebRolGet',
    params: {
      ...data
    }
  }

  return request.post(getURL('', '/RPServices'), body);
}



// WEBPACK FOOTER //
// ./src/state/auth/auth.services.js